import { RouteRecordRaw } from 'vue-router';
import { requireAuth } from '@/common/router/navigationGuard';
import { VIEW_MODE } from '@/common/define/common.define';
import { extractAccessibleRoutes } from '@/common/auth/auth.utils';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';
import { BASE_MENU_VALUE } from '@/common/components/organisms/baseMenu/baseMenu.define';
import { requireDomainTargetOrTutorial, requireInstances } from '@/common/router/authGuard';
import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';

const PREFIX_REDSHIFT = 'redshift_';

const redshiftMenu: RouteRecordRaw[] = [
  {
    path: '/redshift/',
    name: `${PREFIX_REDSHIFT}SQL Analysis`,
    component: BaseViewport,
    children: [
      {
        path: 'topNAnalysis',
        name: `${PREFIX_REDSHIFT}Top N Analysis`,
        component: () => import('@/database/views/topNAnalysis/redshift/TopNAnalysis.vue'),
        beforeEnter: [requireInstances],
        meta: {
          category: BASE_MENU_VALUE.PA,
        },
      },
    ],
    beforeEnter: [requireAuth, () => requireDomainTargetOrTutorial('database')],
    meta: {
      rolePermission: {
        [VIEW_MODE.EXEMONE]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DATABASE_REDSHIFT_PA,
        [VIEW_MODE.MAXGAUGE]:
          ROLE_PERMISSION_KEY.MONITORING.MONITORING_REDSHIFT_PERFORMANCE_ANALYSIS,
      },
      viewport: VIEWPORT_TYPE.PA,
    },
  },
  {
    path: '/redshift/',
    name: `${PREFIX_REDSHIFT}Performance Analysis`,
    component: BaseViewport,
    children: [
      {
        path: 'trendAnalysis',
        name: `${PREFIX_REDSHIFT}Trend Analysis`,
        component: () => import('@/database/views/trendAnalysis/redshift/TrendAnalysis.vue'),
        beforeEnter: [requireInstances],
        meta: { category: BASE_MENU_VALUE.PA },
      },
    ],
    beforeEnter: [requireAuth, () => requireDomainTargetOrTutorial('database')],
    meta: {
      rolePermission: {
        [VIEW_MODE.EXEMONE]: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DATABASE_REDSHIFT_PA,
        [VIEW_MODE.MAXGAUGE]:
          ROLE_PERMISSION_KEY.MONITORING.MONITORING_REDSHIFT_PERFORMANCE_ANALYSIS,
      },
      viewport: VIEWPORT_TYPE.PA,
    },
  },
];

const subMenuMappingRedshift = {
  instanceView: `${PREFIX_REDSHIFT}Real Time Monitoring`,
  sqlAnalysis: `${PREFIX_REDSHIFT}SQL Analysis`,
  performanceAnalysis: `${PREFIX_REDSHIFT}Performance Analysis`,
};

const getRedshiftNaviMenu = (subMenu?: string) => {
  const filteredRedshiftMenu = extractAccessibleRoutes(redshiftMenu);

  if (subMenu && subMenuMappingRedshift[subMenu]) {
    return filteredRedshiftMenu.filter((menu) => menu.name === subMenuMappingRedshift[subMenu]);
  }

  return filteredRedshiftMenu;
};

export { redshiftMenu, getRedshiftNaviMenu, PREFIX_REDSHIFT };
